package nl.staartvin.solarpower.data.rivm

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonObject

// Wire shape for the RIVM WMS GetFeatureInfo response (GeoJSON FeatureCollection).
// We pull `properties` as a raw JsonObject because there are 147 dynamically-named
// "BandN" fields — declaring all of them by hand would be cruel.

@Serializable
internal data class RivmResponse(
    val features: List<RivmFeature>,
)

@Serializable
internal data class RivmFeature(
    val properties: JsonObject,
)
